/**
 * FoamClub — "+ Sacola" do REF-CARD.
 * Adiciona 1 unidade via /cart/add.js com o mesmo contrato do
 * product-form (CartLinesUpdateEvent + sections), abrindo o cart drawer.
 */

import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * @param {HTMLButtonElement} button
 */
async function addToBag(button) {
  const variantId = Number(button.dataset.variantId);
  if (!variantId) return;

  const items = [{ id: variantId, quantity: 1 }];
  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : null))
    .filter(Boolean);

  button.disabled = true;

  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: sectionIds.join(',') }),
    });
    const data = await response.json();
    if (data.status) throw new Error(data.message || 'add failed');

    const cart = await fetch(`${Theme.routes.cart_url}.js`).then((res) => res.json());

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'foam-card-add',
        sourceId: 'foam-card-add',
        itemCount: 1,
        sections: data.sections,
        didError: false,
      },
    });
  } catch (error) {
    deferred.reject(error);
    if (button.dataset.textError) button.setAttribute('title', button.dataset.textError);
  } finally {
    button.disabled = false;
  }
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-foam-card-add]');
  if (!(button instanceof HTMLButtonElement)) return;
  event.preventDefault();
  event.stopPropagation();
  addToBag(button);
});
